export default "__VITE_ASSET__CSZUbPpg__"